var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticStyle:{"display":"inline"}},[_c('i',{staticClass:"fa fa-question-circle text-white",staticStyle:{"cursor":"pointer","padding-top":"0.8rem"},attrs:{"id":"helpTour"},on:{"click":function($event){return _vm.start()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }